import { useLanguage } from "contexts/LanguageContext";
import Modal from "./Modal";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

interface ConfirmDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  deleteMessage: string;
  deleteWarning: string;
}

const ConfirmDeleteModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  deleteMessage,
  deleteWarning
}: ConfirmDeleteModalProps) => {
  const { t } = useLanguage();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="md"
    >
      <div className="p-6 space-y-4">
        <div className="flex items-center">
          <div className="flex-shrink-0 mr-3">
            <ExclamationTriangleIcon className="h-10 w-10 text-red-500" />
          </div>
          <div className="flex-1">
            <p className="text-red-600 font-semibold"> {deleteMessage} </p>
            <p className="text-sm text-gray-500 mt-2"> {deleteWarning} </p>
          </div>
        </div>
        <div className="flex justify-end gap-2 mt-4">
          <button
            onClick={onClose}
            className="px-4 py-2 text-xs font-medium rounded-md bg-gray-200 text-gray-700 hover:bg-gray-300"
          >
            {t('common.actions.cancel')}
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 text-xs font-medium rounded-md bg-red-600 text-white hover:bg-red-700"
          >
            {t('common.actions.delete')}
          </button>
        </div>
      </div>
    </Modal>
  );
};
export default ConfirmDeleteModal